// `apps/web` entrypoint. Mounts <App /> into #root.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { ThemeProvider } from "@link/ui";
import "@link/ui/styles";
import "./components/role-name.css";
import "./components/messages/emoji-picker.css";

import { App } from "./App";
import { SessionStartup } from "./components/auth/SessionStartup";
import { AiSessionProvider } from "./state/AiSession";
import { RealtimeProvider } from "./state/Realtime";
import { MediaSessionProvider } from "./state/MediaSession";
import { SelfSessionProvider } from "./state/SelfSession";
import { UploadsProvider } from "./state/Uploads";
import { DesktopUpdatesProvider } from "./state/DesktopUpdates";

const rootEl = document.getElementById("root");
const updateMotionVisibility = () => {
  document.documentElement.dataset.pageHidden = String(document.hidden);
};
updateMotionVisibility();
document.addEventListener("visibilitychange", updateMotionVisibility);
import.meta.hot?.dispose(() => document.removeEventListener("visibilitychange", updateMotionVisibility));
if (rootEl === null) {
  throw new Error("missing #root element");
}

// The real identity is loaded from /v1/me as soon as an authenticated
// session exists. These values are only a short loading-shell fallback.
const initialIdentity = {
  name: "Link user",
  username: "link_user",
  usernameChangeAvailableAt: null,
  tag: "",
  accountXid: "",
  avatarUrl: null,
  bannerUrl: null,
  bannerColor: "#ee7f9f",
  bannerMode: "solid" as const,
  bannerSecondaryColor: "#9b7bd3",
  communityTag: null,
  customStatus: null,
  pronouns: null,
  memberSince: "2025-12-01",
  selfNote: "",
  badges: [] as const,
};

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <DesktopUpdatesProvider>
      <SessionStartup>
      <SelfSessionProvider initial={initialIdentity}>
        <AiSessionProvider>
          <RealtimeProvider>
            <MediaSessionProvider>
              <UploadsProvider>
                <App />
              </UploadsProvider>
            </MediaSessionProvider>
          </RealtimeProvider>
        </AiSessionProvider>
      </SelfSessionProvider>
      </SessionStartup>
      </DesktopUpdatesProvider>
    </ThemeProvider>
  </StrictMode>,
);
